import { render } from "./PhPaperclip.vue?vue&type=template&id=90084f14"
import script from "./PhPaperclip.vue?vue&type=script&lang=js"
export * from "./PhPaperclip.vue?vue&type=script&lang=js"
script.render = render

export default script